import React, { useContext, useState, useEffect, useRef } from "react";
import { Socket } from 'socket.io-client';
import ChatGlobalContext from "../context/ChatGlobalContext";
import { validateInput } from "../utils/validate";
import loadingIcon from '../assets/images/loader-transparent.gif';
import icoUpload from '../assets/images/youfibre-upload.svg';
import icoClose from '../assets/images/close.svg';
import { connectToWebsocket, didAgentPost, sendMessage } from "../services/chatService";
import InputForm from "./styled/InputForm";

const ChatInput = ({open, attachmentFiles, setAttachmentFiles}) => {
    const gContext: any = useContext(ChatGlobalContext);
    const [chatSending, setChatSending] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const sc = useRef<Socket | null>(null);

    useEffect(() => { 
        if(typeof document !== "undefined" && message.length && gContext?.goGetTwilioChat()?.chatCaseId){ 
            if(!sc.current) sc.current = connectToWebsocket(localStorage.getItem('chatSessionId'));
            sc.current && sc.current?.emit(`web-chat-input`, {
                caseId: gContext?.goGetTwilioChat()?.chatCaseId,
                conversationId: gContext?.goGetTwilioChat()?.chatConversationId,
                message: message,
                sender: 'CUSTOMER'
            });
            gContext?.goSetTwilioChat({...gContext?.goGetTwilioChat(), lastTimeActive: Date.now()});
        }
    }, [message]);
  
    useEffect(() => {
      if(gContext?.goGetTwilioChat()?.chatCaseId){
        sc.current && gContext?.goGetTwilioChat()?.chatCaseId && sc.current.emit("joinRoom", gContext?.goGetTwilioChat()?.chatCaseId);  
      }
    }, [gContext?.goGetTwilioChat()?.chatCaseId]);
  
    useEffect(() => {
      !chatSending && document.getElementById('inputMessage')?.focus();
    }, [chatSending]);

    const submitMessage = async (e, msg = "") => {
        e.preventDefault();
        try {
            setMessage('');
            setChatSending(true);
            const data = await sendMessage(msg, attachmentFiles, 'CUSTOMER');
            if(data){
                gContext?.goSetTwilioChat({...gContext?.goGetTwilioChat(), 
                    logged: true,
                    chatLoading: false,
                    lastTimeActive: didAgentPost(gContext?.goGetTwilioChat()?.messages) ? Date.now() : null,
                });
                setAttachmentFiles([]);
                setChatSending(false);
            } else if (data === null){
              gContext?.goResetTwilioChat();
              setChatSending(false);
            } else {
              setChatSending(false);
            }
        } catch (error) {
            setChatSending(false);
        }
    };

    // Upload files - Remove file from list
    const removeFile = (name:string) => {
      const tmpFiles = attachmentFiles.filter((itm:any) => itm.name !== name);
      setAttachmentFiles(tmpFiles);
    };

    return (
        <>
        {gContext?.goGetTwilioChat()?.chatConversationId && 
          <InputForm>
            <div className="wrapper">
              <input id="inputMessage" className={!validateInput(message) ? 'invalid' : ''} disabled={chatSending} autoComplete='off' maxLength={500} onChange={(e) => setMessage(e.target.value)} value={message} type="text" placeholder="Write a reply..." />
              { chatSending && <img src={loadingIcon} width={10} height={10} /> }
              <img className='action' alt='Add attachment' src={icoUpload} onClick={() => open()} />
              <button type='submit' onClick={(e) => submitMessage(e, message)} disabled={!validateInput(message) || chatSending}>Send</button>
            </div>
          </InputForm>}        
        {attachmentFiles && Object.keys(attachmentFiles).length > 0 && <div className='files'>
          {attachmentFiles.map((file:any) => (
            <div className='file' key={file.name}>
              <div className='fileName'>{file.name}</div>
              <img className='action' src={icoClose} onClick={() => removeFile(file.name)} />
            </div>
          ))}
        </div>}
        </>
    );
};

export default ChatInput;